import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from 'vue';
import { useResizeObserver, useScroll } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'UiTabsNew',
  setup(__props) {

const tabs = ref();
const isScrollable = ref(false);
const tabsScrolledEl = ref<HTMLElement | null>(null);

const useScrollReturn = computed(() =>
  tabsScrolledEl.value ? useScroll(tabsScrolledEl.value) : null,
);

const scrollState = computed(() =>
  useScrollReturn.value ? useScrollReturn.value.arrivedState : null,
);

const isEnd = computed(() =>
  scrollState.value ? scrollState.value.right : true,
);
const isBegin = computed(() =>
  scrollState.value ? scrollState.value.left : true,
);

watch(tabs, (newValue) => {
  if (newValue) {
    const tabsComponentEl = newValue.$el;
    const tabsComponentNavEl = tabsComponentEl.querySelector('.p-tabview-nav');
    tabsScrolledEl.value = tabsComponentEl.querySelector(
      '.p-tabview-nav-content',
    );
    // eslint-disable-next-line no-param-reassign
    newValue.backwardIsDisabled = false;
    // eslint-disable-next-line no-param-reassign
    newValue.forwardIsDisabled = false;
    isScrollable.value =
      tabsComponentNavEl.scrollWidth > tabsComponentNavEl.offsetWidth;
    useResizeObserver(tabsComponentNavEl, (entries) => {
      const { target } = entries[0];

      isScrollable.value =
        target.scrollWidth > (target as HTMLElement).offsetWidth;
    });
    setInterval(() => {
      // eslint-disable-next-line no-param-reassign
      newValue.backwardIsDisabled = false;
      // eslint-disable-next-line no-param-reassign
      newValue.forwardIsDisabled = false;
    }, 0);
  }
});

return { __sfc: true,tabs, isScrollable, tabsScrolledEl, useScrollReturn, scrollState, isEnd, isBegin }
}

})